import React, { useEffect, useState, useRef } from "react";
import { classNames } from "../../helpers/classNames";

const Input = ({
  label,
  labelClasses,
  inputType = "text",
  inputClasses,
  inputPlaceholder,
  inputValue,
  inputName,
  errorText = "", // ← simplified: just the message
  isDisabled,
  value,
  required,
  iconClasses,
  maxLength,
  onChange = () => {},
  onEnterClicked = () => {},
  ...props
}) => {
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const passwordInput = useRef(null);

  const handleClick = () => {
    setPasswordVisibility(!passwordVisibility);
  };

  useEffect(() => {
    if (inputType === "password" && passwordInput.current) {
      passwordInput.current.type = passwordVisibility ? "text" : "password";
    }
  }, [passwordVisibility, inputType]);

  const showError = !!errorText;

  return (
    <div className="w-full relative">
      {label && (
        <div
          className={classNames(
            "text-xs font-medium text-shades-07 mb-1 font-CanelaDeck",
            labelClasses
          )}
        >
          {label}
          {required && (
            <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
              <i className="fa-solid fa-asterisk"></i>
            </span>
          )}
        </div>
      )}

      <div className="relative flex">
        <input
          type={inputType}
          ref={passwordInput}
          className={classNames(
            "w-full h-10 rounded-md placeholder:text-shades-07 bg-white border px-3 font-CanelaDeck text-sm text-gable-green !ring-0 !outline-0 transition-all duration-200",
            showError
              ? "border-red-500 focus:border-red-500"
              : "border-shades-05/50 focus:border-shades-07",
            inputClasses
          )}
          value={value}
          maxLength={maxLength}
          placeholder={inputPlaceholder}
          name={inputName}
          autoComplete={"new-" + inputType}
          onChange={onChange}
          onKeyDown={(e) => e.key === "Enter" && onEnterClicked()}
          disabled={isDisabled}
          {...props}
        />

        {inputType === "password" && (
          <button
            type="button"
            className={classNames(
              "h-full aspect-square absolute top-0 right-0 bg-transparent text-slate-500",
              iconClasses
            )}
            onClick={handleClick}
          >
            <i
              className={classNames(
                "fa-regular fa-fw",
                passwordVisibility ? "fa-eye-slash" : "fa-eye"
              )}
            ></i>
          </button>
        )}
      </div>

      {showError && (
        <div className="text-xs text-red-600 mt-1">
          <i className="fa-regular fa-fw fa-square-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
    </div>
  );
};

export default Input;
